import React from 'react';
import { format, parse } from 'date-fns';

import cellRenderer from './cellRenderer';
import styles from './dateTimeRenderer.scss';

const dateTimeRenderer = (dateFormat) => ({ cellData }) => {
  const parsedDate = parse(cellData, dateFormat, new Date());

  const result = [
    <span key="date" className={styles.date}>
      {format(parsedDate, 'MMM. dd, yyyy')}
    </span>,
    <span key="time" className={styles.time}>
      &nbsp; at {format(parsedDate, 'h:mma')}
    </span>,
  ];

  return cellRenderer({ cellData: result });
};

export default dateTimeRenderer;
